import AnimatedKeyConcepts from './AnimatedKeyConcepts.vue'
import KeyConceptSection from './KeyConceptSection.vue'
import KeywordsContainer from './KeywordsContainer.vue'
import ResearchQuestionDisplay from './ResearchQuestionDisplay.vue'
import ResearchQuestionInput from './ResearchQuestionInput.vue'
import SearchAIContainer from './SearchAIContainer.vue'
import SearchAIHeader from './SearchAIHeader.vue'
import SearchAISubtitle from './SearchAISubtitle.vue'

export {
  AnimatedKeyConcepts,
  KeyConceptSection,
  KeywordsContainer,
  ResearchQuestionDisplay,
  ResearchQuestionInput,
  SearchAIContainer,
  SearchAIHeader,
  SearchAISubtitle
}



// WEBPACK FOOTER //
// ./src/components/parts/searchAi/index.js